<template>
  <div class="evaList">
    <mt-header title="我的评价">
      <mt-button icon="back" slot="left" @click.native="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="content">
      <div class="title">
        <div class="lineOne">
          <div class="stars" v-if="percent.star==5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==4.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==4">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==3.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==3">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==2.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==2">
            <icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==1.5">
            <icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==1">
            <icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==0.5">
            <icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="percent.star==0">
            <icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <p>信誉度<span>{{percent.star * 2}}</span></p>
          <p>成交量<span>{{percent.turnover}}</span></p>
          <p>评价数<span>{{labelNum}}</span></p>
        </div>
        <div class="lineTwo">
          <p>准时率<span>{{percent.Punctuality}}%</span></p>
          <p>完成质量<span>{{percent.quality}}%</span></p>
          <p>满意度<span>{{percent.Satisfaction}}%</span></p>
        </div>
      </div>
      <div class="evaluate">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
        <div class="evaluate_list"  v-for="(evaluateList, index) in evaluateList" :key="index">
          <h1>{{evaluateList.projectName}}</h1>
          <p v-if="who"><span>{{evaluateList.employName}}</span> > 给我的评价</p>
          <p v-else>我给 > <span>四个字</span> 评价</p>
          <p class="time">{{evaluateList.appraiseDate}}</p>
          <div class="starWrap">
            <div class="stars" v-if="evaluateList.appraiseStars==5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><span>10.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==4.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><span>9.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==4">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><span>8.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==3.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><span>7.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==3">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>6.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==2.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>5.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==2">
              <icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>4.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==1.5">
              <icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>3.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==1">
              <icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>2.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==0.5">
              <icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>1.0</span>
            </div>
            <div class="stars" v-else-if="evaluateList.appraiseStars==0">
              <icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>无评价</span>
            </div>
            <p>{{evaluateList.note}}</p>
          </div>
          <!-- <div class="label">
            <span v-for="(evaluateLabelList,index) in evaluateList.appraiseLabels" :key="index" v-if="evaluateLabelList!=''">
              {{evaluateLabelList}}
            </span>
          </div> -->
          <div class="label" v-if="evaluateList.appraiseLabels.length >0 ">
            <span v-for="(evaluateLabelList,index) in evaluateList.appraiseLabels" :key="index">
              {{evaluateLabelList}}
            </span>
          </div>
        </div>
        </mt-loadmore>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
export default {
  name: 'evaList',
  data () {
    return {
      myStar: '3',
      evaluateStar: '2',
      accountId: this.STATE.state.loginId,
      searchCondition: {
        pageNo: '1',
        pageSize: '8'
      },
      allLoaded: false,
      evaluateList: '',
      evaluateLabelList: '',
      appraiseLabel: '',
      percent: '',
      labelNum: 0,
      who: true
    }
  },
  mounted () {
    this.evaluate()
    this.account()
    this.appraiseNum()
  },
  methods: {
    loadTop: function () {
      this.evaluate()
      this.$refs.loadmore.onTopLoaded()
    },
    loadBottom: function () {
      this.more()
      this.$refs.loadmore.onBottomLoaded()
    },
    evaluate: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/account/userInfo/getEvaluationById?id=' + _this.accountId + '&rows=8&page=1')
      .then(function (res) {
        console.log(_this.accountId)
        Indicator.close()
        _this.evaluateList = res.data.appraise
        _this.appraiseLabel = res.data.appraiseLabel
      }).catch(function (response) {
        Indicator.close()
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios.get('url/account/userInfo/getEvaluationById?id=' + _this.accountId + '&rows=8&page=' + this.searchCondition.pageNo + '')
      .then(function (res) {
        Indicator.close()
        _this.evaluateList = res.data.appraise
        if (_this.evaluateList.length !== 30) {
          _this.allLoaded = true
        }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    account: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/common/getevaluate?id=' + _this.accountId + '')
      .then(function (res) {
        Indicator.close()
        _this.percent = res.data.data
      }).catch(function (response) {
        Indicator.close()
      })
    },
    appraiseNum: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.post('url/account/userInfo/getPageInfo?id=' + _this.accountId + '&rows=8&page=1')
      .then(function (res) {
        Indicator.close()
        _this.labelNum = res.data.total
      }).catch(function (response) {
        Indicator.close()
      })
    }
  }
}
</script>

<style scoped>
.evaList{
  background-color:#f0eff5;
}
.title{
  padding: 10px 17px;
}
.title{
  border-bottom: 1px solid #ccc;
  margin-bottom: 6px;
  background-color: #fff;
}
.lineOne p,.lineTwo p{
  display: inline;
  font-size: 12px;
  color: #8a8a8a;
}
.lineOne p span,.lineTwo p span{
  font-size: 17px;
  color: #000;
  font-weight: bold;
  margin-left: 5px;
}
.lineTwo{
  margin-top: 5px;
}
.stars{
  display: inline;
  vertical-align: middle;
  margin-right: 5px;
  line-height: 20px;
}
.stars .fa-icon{
  color: #fd9100;
  transform: scale(0.7);
}
.evaluate{
  background-color: #fff;
  border-top: 1px solid #ccc;
  margin-bottom: 70px;
}
.evaluate_list{
  border-bottom: 1px solid #ccc;
  padding: 10px 17px;
}
.evaluate_list h1{
  font-size: 14px;
}
.evaluate_list p{
  color: #727272;
  font-size: 12px;
  display: inline-block;
}
.evaluate_list .time{
  float: right;
  margin-top: 4px;
}
.starWrap{
  border: 1px solid #ccc;
  padding: 8px;
  box-sizing: border-box;
  margin: 10px 0;
}
.starWrap .stars span{
  font-size: 14px;
  margin-left: 10px;
  vertical-align: text-top;
}
.starWrap p{
  display: block;
  font-size: 12px;
  color: #9e9e9e;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label span{
  font-size: 12px;
  color: #fe9200;
  border: 1px solid #fe9200;
  -webkit-border-radiu:3px;
  -moz-border-radiu:3px;
  border-radius:3px;
  padding: 1px 10px;
  margin: 5px;
}
</style> 



// WEBPACK FOOTER //
// evaluateList.vue?066fd26e